import { Flex } from '@mantine/core';

import { Text } from '~/domains/design-system/Text';

export function MarketsErrorMessage() {
  return (
    <Flex justify="center" align="center" /* eslint-disable-line local-rules/use-theme-tokens */ py={40}>
      <Text variant="subhead-medium" c="gray2.3">
        No markets available
      </Text>
    </Flex>
  );
}
